import React from 'react';
import { FileText, Trash2 } from 'lucide-react';
import styles from './styles.module.css';
import ConfirmDeleteModal from "../ConfirmDeleteModal";

function PrevCard({ invoice, onClick , onDelete }) {

  const formatDate = (date) =>
    new Date(date).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

  const formatCurrency = (value) =>
    value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

 const getStatusClassName = (status) => {
    const s = String(status||'').toLowerCase();
    if (s === 'pago'|| s === 'paga') return `${styles.statusBadge} ${styles.paga}`;
    if (s === 'pendente') return `${styles.statusBadge} ${styles.pendente}`;
    if (s === 'enviada') return `${styles.statusBadge} ${styles.enviada}`;
    if (s === 'confirmada') return `${styles.statusBadge} ${styles.confirmada}`;
    if (s === 'cancelado' || s === 'cancelada') return `${styles.statusBadge} ${styles.cancelada}`;
    return styles.statusBadge;
};

  return (
    <div className={styles.card} onClick={onClick}>
      <div className={styles.itemLeft}>
        <div className={`${getStatusClassName(invoice.status)} ${styles.iconWrapper}`}>
          <FileText size={24} />
        </div>
        <div className={styles.info}>
          <p className={styles.title}>
            Nota <span>#{invoice.number || invoice._id.slice(-4)}</span>
          </p>
          <p className={styles.desc}>
            {invoice.services[0]?.description || '—'} -{' '}
            <span>Cliente: {invoice.recipient?.name || "Desconhecido"}</span>
          </p>
        </div>
      </div>

      <div className={styles.itemRight}>
  
        <div className={styles.statusRow}>
          <span className={getStatusClassName(invoice.status)}>
            {invoice.status}
          </span>

          <button
            className={styles.deleteBtn}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(invoice._id);
            }}
          >
            <Trash2 size={22}/>
          </button>
        </div>

        <div className={styles.meta}>
          <p>{formatDate(invoice.dateIssue)}</p>
          <p><strong>{formatCurrency(invoice.totalValue)}</strong></p>
        </div>

      </div>
    </div>
  );
}

export default PrevCard;
